var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding no-v-padding",staticStyle:{"height":"100%"}},[_c('b-overlay',{staticStyle:{"height":"100%"},attrs:{"show":_vm.loading}},[_c('div',{staticClass:"map",staticStyle:{"height":"100%"},attrs:{"id":"map"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }